import { LocationNumbersService } from '../../../services'

const fetchCustomerPayment = async function ({ commit, state }, locationId) {

  try {
    const data = await LocationNumbersService.getCustomerPayment(locationId)
    commit('setCustomerPayment', data)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default fetchCustomerPayment

